import * as Types from '../generatedTypes';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type SetInvoiceAsPaidMutationVariables = Types.Exact<{
  invoice_id: Types.Scalars['ID'];
  total_in_cent: Types.Scalars['Int'];
  comment: Types.Scalars['String'];
}>;


export type SetInvoiceAsPaidMutation = { __typename?: 'Mutation', setInvoiceAsPaid?: boolean | null };


export const SetInvoiceAsPaidDocument = gql`
    mutation setInvoiceAsPaid($invoice_id: ID!, $total_in_cent: Int!, $comment: String!) {
  setInvoiceAsPaid(
    invoice_id: $invoice_id
    total_in_cent: $total_in_cent
    comment: $comment
  )
}
    `;
export type SetInvoiceAsPaidMutationFn = Apollo.MutationFunction<SetInvoiceAsPaidMutation, SetInvoiceAsPaidMutationVariables>;

/**
 * __useSetInvoiceAsPaidMutation__
 *
 * To run a mutation, you first call `useSetInvoiceAsPaidMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetInvoiceAsPaidMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setInvoiceAsPaidMutation, { data, loading, error }] = useSetInvoiceAsPaidMutation({
 *   variables: {
 *      invoice_id: // value for 'invoice_id'
 *      total_in_cent: // value for 'total_in_cent'
 *      comment: // value for 'comment'
 *   },
 * });
 */
export function useSetInvoiceAsPaidMutation(baseOptions?: Apollo.MutationHookOptions<SetInvoiceAsPaidMutation, SetInvoiceAsPaidMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SetInvoiceAsPaidMutation, SetInvoiceAsPaidMutationVariables>(SetInvoiceAsPaidDocument, options);
      }
export type SetInvoiceAsPaidMutationHookResult = ReturnType<typeof useSetInvoiceAsPaidMutation>;
export type SetInvoiceAsPaidMutationResult = Apollo.MutationResult<SetInvoiceAsPaidMutation>;
export type SetInvoiceAsPaidMutationOptions = Apollo.BaseMutationOptions<SetInvoiceAsPaidMutation, SetInvoiceAsPaidMutationVariables>;